// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-9f93bf48],\n.fade-leave-active[data-v-9f93bf48] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-9f93bf48], .fade-leave-to[data-v-9f93bf48] {\n  opacity: 0;\n}\n.gogonghome[data-v-9f93bf48] {\n  padding-top: 4px;\n}\n[data-v-9f93bf48] .v-input {\n  background-color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
